import { useGiftItemBanner } from '@hooks/businessContainer';
import PrismicLink from '@components/PrismicLink';
import GiftItemBannerContent from './GiftItemBannerContent';
import { useGiftItem } from '@hooks/businessContainer';

const GiftItemBanner: React.FC = () => {
  const content = useGiftItemBanner();
  const { addGiftItemToShoppingCart } = useGiftItem();

  if (!content) {
    return null;
  }

  return (
    <>
      <div
        className="gift-item-banner-container"
        onClick={() => {
          'id' in content.redirect_to && addGiftItemToShoppingCart();
        }}
      >
        <PrismicLink link={content.redirect_to}>
          <GiftItemBannerContent content={content} />
        </PrismicLink>
      </div>
      <style jsx>{`
        .gift-item-banner-container {
          display: flex;
          background-color: var(--clr-primary-3);
          align-items: center;
          justify-content: center;
          padding: var(--space-1) 0 var(--space-1) var(--space-2);
          width: 100%;
          height: var(--top-header-banner-height);
          top: 0;
          left: 0;
        }

        @media (max-width: 800px) {
          .gift-item-banner-container {
            justify-content: left;
          }
        }
      `}</style>
    </>
  );
};

export default GiftItemBanner;
